<template>
  <!--<div v-if="fileType==='text'" v-html="content" style="height:100%;overflow-y: auto"></div>-->
  <iframe v-if="fileType==='text'" :src="simple_url" width='100%' height='100%' frameborder='0'></iframe>
  <iframe v-else-if="fileType==='office'" :src="office_url" width='100%' height='100%' frameborder='0'></iframe>
  <div v-else-if="fileType==='pdf'" style="height:100%">
      <embed width="100%" height="100%" name="plugin" id="plugin" :src="simple_url" type="application/pdf" internalinstanceid="113">
  </div>
  <div v-else-if="fileType==='image'" class="dms-preview-image display-flex">
    <img :src="simple_url"/>
  </div>
  <div v-else-if="fileType==='audio'" class="display-flex">
    <audio controls>
      <source :src="simple_url" type="audio/mpeg">
      <source :src="simple_url" type="audio/ogg">Ваш браузер не поддерживается.
    </audio>
  </div>
  <div v-else-if="fileType==='video'" class="mx-auto display-flex">
    <video controls style="max-width: 100%; height: auto">
      <source :src="simple_url" type="video/mp4">
      <source :src="simple_url" type="video/ogg">Ваш браузер не поддерживается.
    </video>
  </div>
  <div v-else class="display-flex">
    <h3 class="display-1">Невозможно отобразить данный файл</h3>
  </div>
</template>

<script>
  export default {
    name : "FileViewer",
    
    props:{
      data: {
        type: Object,
        required: true
      }
    },
    
    created(){
      /*if(this.data.mime.indexOf('text')>-1 && this.data.mime.indexOf('opendocument')<0){
        this.$store.dispatch('disk/getFileContent', this.data.id).then(response => {
          this.content = response
        })
      }
      */
    },
    
    computed:{
      office_url(){
        let origin = (location.origin === "https://0.0.0.0:8080") ? "https://dev18.dantser.net" : location.origin
        return 'https://view.officeapps.live.com/op/embed.aspx?src='+origin+'/disk/d/'+this.data.token+'&embedded=true'
      },
      simple_url(){
        return '/disk/d/'+this.data.token
      },
      fileType(){
        if(this.data.mime.indexOf('rtf')>-1) return 'unknown'
        if(this.data.mime.indexOf('opendocument')>-1) return 'office'
        if(this.data.mime.indexOf('text')>-1) return 'text'
        if(this.data.mime.indexOf('image')>-1) return 'image'
        if(this.data.mime.indexOf('pdf')>-1) return 'pdf'
        if(this.data.mime.indexOf('audio')>-1) return 'audio'
        if(this.data.mime.indexOf('video')>-1) return 'video'
        if(this.data.mime.indexOf('excel')>-1) return 'office'
        if(this.data.mime.indexOf('msword')>-1) return 'office'
        if(this.data.mime.indexOf('office')>-1) return 'office'
        return 'unknown'
      },
    },
    
    beforeDestroy(){
      this.$emit('destroy')
    },
    
    data(){
      return {
        content: ''
      }
    },
    
    methods: {
    
    }
  }
</script>

<style scoped>
  .dms-preview-image img{
    max-width: 100%;
    max-height: 100%;
    display: block;
    margin: 0 auto;
  }
  .display-flex{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>


// WEBPACK FOOTER //
// src/apps/disk/components/FileViewer/FileViewer.vue